<template>
    <div class="richtext-renderer">
        <!-- 语雀官方渲染器容器 -->
        <div id="lake-viewer" ref="viewerRef" class="ne-doc-major-viewer"></div>
    </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'

const props = defineProps({
    content: {
        type: String,
        default: ''
    }
})

const viewerRef = ref()
let viewer = null

// 加载语雀脚本和样式
const loadYuqueAssets = () => {
    return new Promise((resolve, reject) => {
        // 检查是否已经加载
        if (window.Doc && window.Doc.createOpenViewer) {
            resolve()
            return
        }

        // 加载CSS
        const docCss = document.createElement('link')
        docCss.rel = 'stylesheet'
        docCss.href = 'https://gw.alipayobjects.com/render/p/yuyan_npm/@alipay_lakex-doc/1.24.0/umd/doc.css'
        document.head.appendChild(docCss)

        const antdCss = document.createElement('link')
        antdCss.rel = 'stylesheet'
        antdCss.href = 'https://unpkg.com/antd@4.24.13/dist/antd.css'
        document.head.appendChild(antdCss)

        // 加载React
        const loadReact = () => {
            return new Promise((resolveReact) => {
                if (window.React && window.ReactDOM) {
                    resolveReact()
                    return
                }

                const reactScript = document.createElement('script')
                reactScript.src = 'https://unpkg.com/react@18/umd/react.production.min.js'
                reactScript.crossOrigin = 'anonymous'
                reactScript.onload = () => {
                    const reactDOMScript = document.createElement('script')
                    reactDOMScript.src = 'https://unpkg.com/react-dom@18/umd/react-dom.production.min.js'
                    reactDOMScript.crossOrigin = 'anonymous'
                    reactDOMScript.onload = () => resolveReact()
                    reactDOMScript.onerror = reject
                    document.head.appendChild(reactDOMScript)
                }
                reactScript.onerror = reject
                document.head.appendChild(reactScript)
            })
        }

        // 先加载React，再加载语雀脚本
        loadReact().then(() => {
            const docScript = document.createElement('script')
            docScript.src = 'https://gw.alipayobjects.com/render/p/yuyan_npm/@alipay_lakex-doc/1.24.0/umd/doc.umd.js'
            docScript.onload = () => resolve()
            docScript.onerror = reject
            document.head.appendChild(docScript)
        }).catch(reject)
    })
}

// 初始化查看器
const initViewer = () => {
    if (!window.Doc || !window.Doc.createOpenViewer || !viewerRef.value) {
        return
    }

    const { createOpenViewer } = window.Doc
    viewer = createOpenViewer(viewerRef.value, {
        // 尝试设置为流式布局，充满容器宽度
        layoutMode: 'fluid',
        maxWidth: '100%',
        width: '100%'
    })

    if (props.content) {
        viewer.setDocument('text/lake', props.content)
    }

    // 暴力修改所有可能限制宽度的元素
    setTimeout(() => {
        const allElements = viewerRef.value.querySelectorAll('*')

        allElements.forEach(el => {
            const computedStyle = window.getComputedStyle(el)
            // 如果元素有固定宽度限制，强制修改
            if (computedStyle.maxWidth && computedStyle.maxWidth !== 'none' &&
                (computedStyle.maxWidth.includes('px') || computedStyle.maxWidth.includes('rem'))) {
                el.style.setProperty('max-width', 'none', 'important')
                el.style.setProperty('width', '100%', 'important')
            }
        })

        console.log('已强制修改所有宽度限制')
    }, 500)
}

// 监听内容变化
watch(() => props.content, (newContent) => {
    if (viewer && newContent) {
        viewer.setDocument('text/lake', newContent)
    }
})

onMounted(() => {
    loadYuqueAssets().then(() => {
        initViewer()
    }).catch(error => {
        console.error('加载语雀资源失败:', error)
    })
})

defineExpose({
    setContent: (content) => {
        if (viewer) {
            viewer.setDocument('text/lake', content)
        }
    },
    getViewer: () => viewer
})
</script>

<style scoped>
.richtext-renderer {
    width: 100%;
    min-height: 200px;
}

#lake-viewer.ne-doc-major-viewer {
    width: 100%;
    min-height: 200px;
}

/* 恢复之前有效的宽度设置 */
#lake-viewer.ne-doc-major-viewer :deep(.ne-viewer) {
    width: 100% !important;
    max-width: 100% !important;
}

#lake-viewer.ne-doc-major-viewer :deep(.ne-viewer-body) {
    width: 100% !important;
    max-width: 100% !important;
    padding: 16px !important;
}
</style>